import { idtype, linkTo } from "querypieces";

export default `
  ...on pageBuilder_waysToGetInvolved_BlockType {
    ${idtype}
    waysToGetInvolved {
      ...on waysToGetInvolvedItem_Entry {
        id
        heading
        overview
        commitmentLevel
        commitmentMore
        ${linkTo}
      }
    }
  }
`;
